import { useEffect } from 'react';
import { openUrl } from '../components/utils/utils';

function useOverrideInAppLinks(targetEle, content) {
  useEffect(() => {
    if (!window.AlfredJsBridge) return;

    if (targetEle && content) {
      const linkElements = targetEle.querySelectorAll('a[href^="https://"]');
      if (linkElements.length <= 0) return;

      linkElements.forEach((link) => {
        link.onclick = (e) => {
          e.preventDefault();
          openUrl(link.href, { view: 'browser', direction: 'up' });
        };
      });
    }
  }, [content, targetEle]);
}
export default useOverrideInAppLinks;
